export const STOCK_RECEIPT_RECEIPT_DATE_TIP =
  '製造商開單日，非實際收貨日。';
